


import { createAction as ngrxCreateAction, props, Action } from '@ngrx/store';

export const INIT_SCREEN = '[Master perfilUsuario] Init';
export const DESTROY_SCREEN = '[Master perfilUsuario] Destroy';

export const INIT_STATE = '[Master perfilUsuario] Init State';
export const INIT_VALUE = '[Master perfilUsuario] Init Value';
export const INIT_VALUE_SUCCESS = '[Master perfilUsuario] Init Value Success';
export const INIT_VALUE_FAIL = '[Master perfilUsuario] Init Value Fail';
export const FETCH_FIELD_POSSIBLE_VALUES =
  '[Master perfil-usuario] Fetch Field Possible Values';
export const FETCH_FIELD_POSSIBLE_VALUES_SUCCESS =
  '[Master perfil-usuario] Fetch Field Possible Values Success';
export const FETCH_FIELD_POSSIBLE_VALUES_FAIL =
  '[Master perfil-usuario] Fetch Field Possible Values Fail';

export const UPDATE_DATA = "[Master perfilUsuario] Update Data";


    export const ANTERIOR = '[Master perfilUsuario] Anterior';
export const ANTERIOR_SUCCESS = '[Master perfilUsuario] Anterior Success';
export const ANTERIOR_FAIL = '[Master perfilUsuario] Anterior Fail';


    export const PROXIMO = '[Master perfilUsuario] Proximo';
export const PROXIMO_SUCCESS = '[Master perfilUsuario] Proximo Success';
export const PROXIMO_FAIL = '[Master perfilUsuario] Proximo Fail';




export const initAction = ngrxCreateAction(INIT_SCREEN, payload => payload);

export const destroyAction = ngrxCreateAction(DESTROY_SCREEN, payload => payload);

  // Anterior action
export const anteriorAction = ngrxCreateAction(ANTERIOR,payload => payload);

export const anteriorSuccessAction = ngrxCreateAction(ANTERIOR_SUCCESS,payload => payload);

export const anteriorFailAction = ngrxCreateAction(ANTERIOR_FAIL, payload => payload);
  // Proximo action
export const proximoAction = ngrxCreateAction(PROXIMO,payload => payload);

export const proximoSuccessAction = ngrxCreateAction(PROXIMO_SUCCESS,payload => payload);

export const proximoFailAction = ngrxCreateAction(PROXIMO_FAIL, payload => payload);



        

export const initStateAction = ngrxCreateAction(INIT_STATE,payload => payload);

export const initValueAction = ngrxCreateAction(INIT_VALUE,payload => payload);

export const initValueSuccessAction = ngrxCreateAction(INIT_VALUE_SUCCESS,payload => payload);

export const initValueFailAction = ngrxCreateAction(INIT_VALUE_FAIL,payload => payload);
export const fetchFieldPossibleValuesAction = ngrxCreateAction(FETCH_FIELD_POSSIBLE_VALUES,payload => payload);
export const fetchFieldPossibleValuesSuccessAction = ngrxCreateAction(FETCH_FIELD_POSSIBLE_VALUES_SUCCESS,payload => payload);
export const fetchFieldPossibleValuesFailAction = ngrxCreateAction(FETCH_FIELD_POSSIBLE_VALUES_FAIL,payload => payload);


                            


export const updateDataAction = ngrxCreateAction(
  UPDATE_DATA,
  payload => payload
);

